import React, { Component } from "react";
import styled from "styled-components";
import { themeColors } from "../../../../react/sharedStyles";
import { AiIcon } from "../../AiIcon";
import anime from "animejs";
import { $ } from "js/vendor";
import PresentationEditorController, { PanelType } from "../../../PresentationEditor/PresentationEditorController";
import { ShowDialog } from "../../../../react/components/Dialogs/BaseDialog";
import SlideAiDialog from "../../SlideAi/SlideAiDialog";
import { delay } from "../../../../core/utilities/promiseHelper";

const Container = styled.div`
    background: ${themeColors.aiColor};
    color: white;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: bold;
    height: 100%;
    z-index: 10000;
    overflow: hidden;

    a {
        padding: 0px 3px;
        text-decoration: underline;
        cursor: pointer;
    }

    div {
        text-wrap: nowrap;
    }
`;

export class SlideAiBanner extends Component {
    constructor(props) {
        super(props);

        this.ref = React.createRef();
    }

    componentDidMount() {
        const { currentCanvasController } = this.props;

        this.unsubscribe = currentCanvasController.selectionLayerController.onSelectionChanged(this.approveAiSlide);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const { currentSlide } = this.props;

        if (prevProps.currentSlide !== currentSlide) {
            if (this.unsubscribe) {
                this.unsubscribe();
            }

            const { currentCanvasController } = this.props;
            this.unsubscribe = currentCanvasController.selectionLayerController.onSelectionChanged(this.approveAiSlide);
        }
        if (prevProps.visible !== this.props.visible) {
            this.approveAiSlide();
        }
    }

    componentWillUnmount() {
        if (this.unsubscribe) {
            this.unsubscribe();
        }
    }

    openBanner = () => {

    }

    approveAiSlide = () => {
        const { currentSlide } = this.props;

        let el = this.ref.current;

        let parentEl = el.parentElement;
        let startBounds = parentEl.getBoundingClientRect();

        let $slideAiButton = $("#slide-ai-panel");
        let targetBounds = $slideAiButton[0].getBoundingClientRect();

        let $highlight = $(el).addEl($.div("slidebanner-highlight").css({
            background: themeColors.aiColor,
            borderRadius: "50%",
            width: "26",
            height: "26",
            position: "absolute",
            // top: (targetBounds.top + (targetBounds.height / 2) - 20) + "px",
            top: 10,
            // left: (targetBounds.left + (targetBounds.width / 2) - 20) + "px",
            zIndex: -1,
            transform: "translate(0px, -10px) scale(.1)"
        }));

        let $icon = $(el).find(".ai-icon")[0];
        console.log($icon);

        // Hide text node
        // el.querySelector("#text").style.opacity = 0;

        let top = parseFloat(parentEl.style.top || 0);
        let timeline = anime.timeline({
            easing: "easeInOutQuad",
        });
        timeline.add({
            targets: parentEl,
            width: targetBounds.width,
            height: targetBounds.height,
            // left: startBounds.left + (startBounds.width / 2) - 20,
            left: targetBounds.left,
            top: top + 5,
            duration: 500,
        }, 0);
        timeline.add({
            targets: $icon,
            scale: [1, .75],
            duration: 300,
        }, 0);
        timeline.add({
            targets: el.querySelector("#text"),
            opacity: [1, 0],
            width: 0,
            duration: 300,
        }, 0);

        timeline.add({
            targets: $highlight[0],
            scale: 6,
            opacity: [1, 0],
            duration: 800,
        }, 300);

        timeline.finished.then(() => {
            timeline.seek(0);
            el.querySelector("#text").style.display = "block";
            $(".slidebanner-highlight").remove();

            currentSlide.update({
                metadata: {
                    ...currentSlide.getMetadata(),
                    aiVariationApproved: true,
                }
            });
        });

        timeline.play();
    }

    showVariations = async () => {
        this.approveAiSlide();
        await delay(500);
        ShowDialog(SlideAiDialog, this.props);
    }

    render() {
        return (
            <Container ref={this.ref}><AiIcon />
                <div id="text">This slide was generated with AI. You can either <a onClick={this.approveAiSlide}>keep it as is</a> or <a onClick={this.showVariations}>view more generated ideas</a>.</div>
            </Container>
        );
    }
}

